import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTabFromHash()
    window.addEventListener("hashchange", this.handleHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange)
  }

  handleHashChange = () => {
    this.showTabFromHash()
  }

  switch(event) {
    const tab = event.currentTarget.dataset.tab
    if (tab) {
      window.location.hash = tab
      this.activate(tab)
    }
  }

  showTabFromHash() {
    const hash = window.location.hash.replace("#", "")
    const validTabs = ["influencer", "advertiser", "campaign", "agency"]
    const tab = validTabs.includes(hash) ? hash : (this.element.dataset.guideTabDefault || "influencer")
    this.activate(tab)
  }

  activate(tab) {
    this.tabTargets.forEach(el => {
      const isActive = el.dataset.tab === tab
      el.style.background = isActive ? "#4F46E5" : "#F9FAFB"
      el.style.color = isActive ? "#fff" : "#6B7280"
      el.style.fontWeight = isActive ? "700" : "500"
      el.style.borderBottom = "none"
    })

    this.panelTargets.forEach(el => {
      el.style.display = el.dataset.tab === tab ? "block" : "none"
    })
  }
}
